import { TemplateElement, defineElement } from '@webtides/element-js';
import style from './svg-icon.css';

const DEFAULT_PATH = `${window.siteConfig().publicPath}/assets/symbol/svg/sprite.symbol.svg`;

class SvgIcon extends TemplateElement {
    constructor() {
        super({ shadowRender: false, styles: [style] });
    }

    properties() {
        return {
            name: '',
            spritePath: window.siteConfig().spritePath,
            svgMaskPath: '',
        };
    }

    template() {
        if (this.svgMaskPath !== '') {
            this.classList.add('svg-mask');
            this.style.setProperty('--svg-mask-url', `url(${this.svgMaskPath})`);
            return ``;
        }
        return `
                <svg>
                    <use xlink:href="${this.spritePath ? this.spritePath : DEFAULT_PATH}#${this.name}"></use>
                </svg>
        `;
    }
}

defineElement('svg-icon', SvgIcon);
